import React from "react";
import { AiOutlineDelete } from "react-icons/ai";

const CartItems = ({ item }) => {
  const { title, text, price, img } = item;

  const handleDelete = () => {};
  return (
    <div className="flex py-3 items-center hover:scale-105 transition-all duration-700 ease-in-out justify-between px-5 shadow-lg mb-2 rounded-md shadow-slate-300">
      <div className=" flex gap-3">
        <div className="relative w-max">
          <img src={img} alt="cart-img" className="w-24 h-auto object-fill" />
          <span className="absolute top-0 right-0 text-xs bg-slate-600 text-slate-100 rounded-md w-8 h-4 text-center">
            {price}
          </span>
        </div>
        <div>
          <h1 className="font-bold capitalize text-slate-800">{title}</h1>
          <span className="capitalize ">{text}</span>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center">
        <h1 className="font-bold text-slate-800">${price}</h1>
        <AiOutlineDelete
          onClick={() => handleDelete()}
          className="text-2xl cursor-pointer hover:scale-100 transition-all ease-in-out duration-700"
        />
      </div>
    </div>
  );
};

export default CartItems;
